<template>
  <div>
    <div class="mt-10 pt-6 px-0 float-left">
      <extra-buttons/>
    </div>

    <component is="simpleAds" :de-active="false"/>

    <!--    <v-tabs v-model="tab" class="mt-5" color="deep-purple accent-4" grow>-->
    <!--      <v-tab v-for="item in TabsName" :key="item.value" @change="getVal(item.value)">{{ item.name }}</v-tab>-->
    <!--    </v-tabs>-->

    <!--    <v-tabs-items v-model="tab">-->
    <!--      <v-tab-item v-for="item in myComponents" :key="item">-->
    <!--        <component :is="item.name" v-if="activeComponent === item.value" :key="item.value" :de-active="false"/>-->
    <!--      </v-tab-item>-->
    <!--    </v-tabs-items>-->
  </div>
</template>

<script>
import SimpleAds from "@/view/pages/ads/singleAds/simpleAds";
import ExtraButtons from "@/view/pages/uiBeautifier/extraButtons";
import DivarMulti from "../mutliAds/divarMulti";

export default {
  name: "taki",

  components: {DivarMulti, ExtraButtons, SimpleAds},

  data() {
    return {
      myComponents: [{name: 'simpleAds', value: 'single'}, {name: 'divarMulti', value: 'multi'},],
      TabsName: [{name: 'ارسال تکی', value: 'single'}, {name: 'ارسال گروهی', value: 'multi'}],
      tab: '',
      activeComponent: 'single'
    }
  },

  methods: {
    getVal(val) {
      this.activeComponent = val
    }
  },
}
</script>

<style scoped>

</style>